const gridUnit = 8;

export enum Dimensions {
    GridUnit = gridUnit,
    NavigationHeight = gridUnit * 11, // *11 with no banner, *15 with banner
    MaxContentWidth = 1500,
}
